<template>
  <div id="operationsContainer">
    <el-button v-if="downMydoc" class="btnBgColor" size="small" type="primary" plain @click="batchDownload">
      <i class="el-icon-download"></i> 下载
    </el-button>
    <el-button v-if="shareMydoc" class="btnBgColor" size="small" type="primary" plain @click="batchShare">
      <i class="el-icon-share"></i>
      分享
    </el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { downloadFile, downloadUrltoken } from "@/CommonDP/utils";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  data() {
    return {
      downMydoc: checkPermission(this.$allPerms.MYCOLLECTION_DOWN),
      shareMydoc: checkPermission(this.$allPerms.MYCOLLECTION_SHARE)
    };
  },
  computed: {
    ...mapState({
      selectArr: (state) => state.XtDesign.selectArr, // 勾选的文件
      userInfo: (state) => state.user.userInfo
    })
  },
  methods: {
    // 分享
    batchShare() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      this.$store.dispatch("XtDesignIsShowShare");
    },
    // 下载1
    batchDownload() {
      const batchArr = this.selectArr;
      const userInfo = this.userInfo;
      const { token } = userInfo;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      const isFolder = batchArr.some((item) => item.isFolder === 1);
      if (isFolder) {
        return this.$message({
          type: "warning",
          message: "文件夹不支持批量下载"
        });
      } else if (batchArr.length > 10) {
        return this.$message.warning("一次批量下载最多选择10个文件");
      } else {
        const prjId = "MyDoc";
        const urls = batchArr.map((item) => {
          return downloadUrltoken(prjId, item.folderId, item.fileVersion);
        });
        for (let i = 0; i < urls.length; i++) {
          downloadFile(urls[i]);
        }
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#operationsContainer {
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: var(--middle-space) var(--big-space);
  box-sizing: border-box;

  .el-button--primary.is-plain {
    background: #fff;
    border-color: #4777E7;
    color: #4777E7;
  }

  .el-button--primary.is-plain:hover {
    background: #E1EAFF;
    border-color: #4777E7;
    color: #4777E7;
  }
}
</style>
